export const parseDateOrNull = (value?: string | Date | null) => (value ? new Date(value) : null);
